import cn from 'classnames';
import { t } from 'i18n';
import { FC, useId } from 'react';
import UrlIcon from 'students/views/shared/components/UrlIcon';
import infoIcon from './assets/info_icon.svg';

interface IAudioHelpTipProps {
  text?: string;
  className?: string;
}

const AudioHelpTip: FC<IAudioHelpTipProps> = ({
  text = t('frontend.member.play.audio.help_tip_trigger', {
    defaultValue: "Don't hear sound?"
  }),
  className
}) => {
  const tooltipId = useId();

  const modalTitle = t('frontend.member.play.audio.help_modal_title', {
    defaultValue: 'No sound?'
  });
  const tips = [
    t('frontend.member.play.audio.help_modal_item_1', {
      defaultValue: 'Make sure sound is on'
    }),
    t('frontend.member.play.audio.help_modal_item_2', {
      defaultValue: 'Turn up the volume'
    }),
    t('frontend.member.play.audio.help_modal_item_3', {
      defaultValue: 'Check your audio output'
    })
  ];

  return (
    <div className={cn('ln-relative ln-mt-3 ln-flex ln-justify-center', className)}>
      <div className="ln-relative ln-inline-flex ln-items-center ln-gap-2 ln-group">
        <button
          type="button"
          className="ln-inline-flex ln-items-center ln-gap-2 ln-bg-transparent ln-border-0 ln-p-0 focus-visible:ln-outline focus-visible:ln-outline-2 focus-visible:ln-outline-white focus-visible:ln-outline-offset-2"
          aria-describedby={tooltipId}
        >
          <UrlIcon url={infoIcon} height="16px" width="16px" />
          <span className="ln-text-white ln-opacity-70 group-hover:ln-opacity-100 group-focus-within:ln-opacity-100 ln-transition-opacity ln-duration-300 ln-delay-300">
            {text}
          </span>
        </button>

        <div
          id={tooltipId}
          role="tooltip"
          className="ln-absolute ln-top-full ln-left-1/2 -ln-translate-x-1/2 ln-mt-2 ln-z-10 ln-w-max ln-max-w-[260px] ln-rounded-md ln-bg-white ln-px-3 ln-py-2 ln-text-left ln-text-sm ln-leading-5 ln-text-black ln-shadow-lg light:ln-shadow-popover ln-pointer-events-none ln-opacity-0 group-hover:ln-opacity-100 group-focus-within:ln-opacity-100 ln-transition-opacity ln-duration-300 ln-delay-300"
        >
          <strong>{modalTitle}</strong>
          <ul className="ln-list-disc ln-mb-0 ln-mt-1 ln-pl-5">
            {tips.map((tip, index) => (
              <li key={index}>{tip}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AudioHelpTip;
